export enum AppRouting {
  USER_MANAGEMENT = 'user-approval',
  ACCESS_CONTROL = 'access-control',
}
